var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#949CAF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.522 8.185h10.087a.522.522 0 0 0 0-1.044H.522a.522.522 0 0 0 0 1.044z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.826 10.967c.134 0 .267-.05.369-.153l2.782-2.782a.522.522 0 0 0 0-.738L8.195 4.51a.522.522 0 0 0-.738.738L9.87 7.663l-2.414 2.414a.522.522 0 0 0 .369.89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.348 15.315c4.219 0 7.652-3.433 7.652-7.652C16 3.443 12.567.011 8.348.011a7.613 7.613 0 0 0-7.122 4.853.522.522 0 0 0 .97.382 6.575 6.575 0 0 1 6.152-4.192 6.617 6.617 0 0 1 6.609 6.609 6.617 6.617 0 0 1-6.61 6.609 6.575 6.575 0 0 1-6.15-4.19.522.522 0 0 0-.971.381 7.613 7.613 0 0 0 7.122 4.852z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.e1464800.svg";
export { ForwardRef as ReactComponent };